import { Controller, type Control } from "react-hook-form";
import { Input } from "antd";
import { ProgramScheduleType } from "../../../../../types/dto/program";

export default function BulkEditProgramSchedulePricesForm({
  control,
}: {
  control: Control<Pick<ProgramScheduleType, "price" | "price_with_prompt_payment_discount">>;
}) {
  return (
    <div className="flex flex-col gap-3">
      <div>
        <label>Valor a pagar</label>
        <Controller
          control={control}
          name="price"
          render={({ field, fieldState }) => (
            <div>
              <Input
                style={{ width: "100%" }}
                placeholder="Ingresa el nuevo monto"
                value={field.value ?? ""}
                onChange={(e) => field.onChange(e.target.value)}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
              />
              {fieldState.error ? (
                <span className="mt-1 block text-xs text-red-500">
                  {fieldState.error.message}
                </span>
              ) : null}
            </div>
          )}
        />
      </div>
      <div>
        <label>Valor pronto pago</label>
        <Controller
          control={control}
          name="price_with_prompt_payment_discount"
          render={({ field, fieldState }) => (
            <div>
              <Input
                style={{ width: "100%" }}
                placeholder="Ingresa el nuevo monto de pronto pago"
                value={field.value ?? ""}
                onChange={(e) => field.onChange(e.target.value)}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
              />
              {fieldState.error ? (
                <span className="mt-1 block text-xs text-red-500">
                  {fieldState.error.message}
                </span>
              ) : null}
            </div>
          )}
        />
      </div>
    </div>
  );
}
